import { t, type I18nLocale } from '@ardoq/i18n';
import { exhaustiveCheck } from '@ardoq/common-helpers';

export enum ViewpointToolBarDisabledReason {
  MULTIPLE_DATASETS = 'multipleDatasets',
  MULTIPLE_TYPES_SELECTED = 'multipleTypesSelected',
  NO_VISIBLE_DATASETS = 'noVisibleDatasets',
}

export type ToolbarButtonId = 'viewpoint' | 'context';

const getDisabledTextForButton = (
  i18nLocale: I18nLocale,
  buttonId: ToolbarButtonId,
  disabledReason: ViewpointToolBarDisabledReason
): string => {
  switch (disabledReason) {
    case ViewpointToolBarDisabledReason.MULTIPLE_DATASETS:
      return buttonId === 'viewpoint'
        ? t(
            i18nLocale,
            'canvas:disabledViewpointMultipleDatasets',
            `You can't change Viewpoints because there are multiple datasets opened. Select a component in your view to use a Viewpoint for it.`
          )
        : t(
            i18nLocale,
            'canvas:disabledContextMultipleDatasets',
            `You can't change context because there are multiple datasets in your view. Select datasets to change context component for each dataset.`
          );
    case ViewpointToolBarDisabledReason.MULTIPLE_TYPES_SELECTED:
      return buttonId === 'viewpoint'
        ? t(
            i18nLocale,
            'canvas:disabledViewpointMultipleTypesSelected',
            `You have selected components of different types. Select components of the same type to use a Viewpoint.`
          )
        : t(
            i18nLocale,
            'canvas:disabledContextMultipleTypesSelected',
            `Your selection or context components are of different types. Change your context components or select components of the same type.`
          );
    case ViewpointToolBarDisabledReason.NO_VISIBLE_DATASETS:
      return buttonId === 'viewpoint'
        ? t(
            i18nLocale,
            'canvas:disabledViewpointNoVisibleDatasets',
            `You can't change Viewpoints because there are no visible datasets in your view. Make a dataset visible to use a Viewpoint for it.`
          )
        : t(
            i18nLocale,
            'canvas:disabledContextNoVisibleDatasets',
            `You can't change context because there are no visible datasets in your view. Make a dataset visible to change its context.`
          );
    default:
      return exhaustiveCheck(disabledReason);
  }
};

export const getDisabledButtonPopoverText = (
  i18nLocale: I18nLocale,
  buttonId: ToolbarButtonId,
  disabledReason: ViewpointToolBarDisabledReason
): string => getDisabledTextForButton(i18nLocale, buttonId, disabledReason);
